export default __webpack_public_path__ + "static/media/hexospark-logo-rectangle-white.e9eda435.svg";